<app-view-title Title="" [isPrimaryColor]="true"></app-view-title>
<view-content [fullscreen]="true" [centered]="true">
  @if(paymentFailed) {
  <ng-container>
    <app-information-screen [centered]="true" [secondaryColor]="true" title="{{ 'Intellitrailer.Booking.PaymentFailed.PaymentNotCompletedTitle' | translate : 'Payment not completed' }}"
                            primaryContent="{{ 'Intellitrailer.Booking.PaymentFailed.PaymentCancelled' | translate : 'The payment was cancelled. Please try again.' }}">
    </app-information-screen>
  </ng-container>
  }
  @if(!returnAction) {
  <ng-container>
    @if(redirecting) {
    <ng-container>
      <app-loading-screen [centered]="true" title="{{ 'Intellitrailer.Booking.Payment.PreparingPayment' | translate : 'Preparing payment' }}" description="{{ 'Intellitrailer.Booking.Payment.msgPreparingPayment' | translate : 'You are being redirected to payment' }}"></app-loading-screen>
    </ng-container>
    }
    @if(!redirecting && amount) {
    <ng-container>
      <app-information-screen [centered]="true" [secondaryColor]="true" title="{{ 'Intellitrailer.Booking.PaymentFailed.InsufficientFunding' | translate : 'This booking is not fully paid' }}"
                              primaryContent="{{ 'Intellitrailer.Booking.PaymentFailed.UnsettledAmount' | translate : 'An additional {0} needs to paid.' : [ amount ] }}"
                              secondaryContent="{{ 'Intellitrailer.Booking.PaymentFailed.UnsettledDescription' | translate : 'Either the booking has changed since it was booked or the credit card you added could not be charged.' }}">
      </app-information-screen>
    </ng-container>
    }
  </ng-container>
  }
</view-content>

<view-actions>
  @if(paymentFailed) {
  <button mat-raised-button (click)="retry()" color="accent">{{ 'Intellitrailer.Booking.Paymen.cmdRetry' | translate : 'Retry' }}</button>
  }
  @if(!returnAction && !redirecting) {
  <button mat-raised-button (click)="redirect()" color="accent">{{ 'Intellitrailer.Booking.Paymen.cmdPay' | translate : 'Pay' }}</button>
  }
</view-actions>

